import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    let title: string = '';

    if (pathname === '/') {
      title = 'BAM - Werklijnen';
    } else if (pathname.startsWith('/plank')) {
      title = 'BAM - Plank';
    } else if (pathname.startsWith('/beheer')) {
      title = 'BAM - Beheer';
    } else if (pathname.startsWith('/mwd-v2')) {
      title = 'BAM MWD';
    } else if (pathname.startsWith('/b-regelingen')) {
      title = 'BAM - B-Regelingen';
    } else if (pathname.startsWith('/agenda')) {
      title = 'BAM - Agenda';
    } else if (pathname.startsWith('/status')) {
      title = 'BAM - Status';
    } else if (pathname.startsWith('/lmm')) {
      title = 'BAM - LMM Staat';
    }

    document.title = title;
  }, [pathname]);
}
